
















































































/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable key-spacing */
/* eslint-disable class-methods-use-this */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import format from '@/libs/numberFormat';
import { api2 } from '@/libs/api';
import SimplePagination from '@/components/SimplePagination.vue';
import { AxiosError } from 'axios';
import Button from '@/components/Button.vue';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import Modal from '@/components/Modal.vue';
import CloseIcon from 'mdi-vue/Close';
import AddIcon from 'mdi-vue/Plus';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import dayjs from 'dayjs';
import excel from 'exceljs';
import { DateRange } from '@/components/DatePicker.vue';
import { User, ReconResponse } from '@/libs/api.interfaces';

@Component({
  components: {
    ScrollbarWrapper,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    SimplePagination,
    Button,
    Modal,
    CloseIcon,
    // AddIcon,
    // Loader,
    // StatusIndicator,
    // ActionPopup,
  },
  methods: {
    format,
  },
  computed: mapState(['user']),
})

export default class UploadHistoryTable extends Vue {
  columns = [];

  rows = [];

  loading = true;
  to = 0;
  totalItem = 0;
  hasNext = true;
  hasPrev = false;
  page = 0;
  searchParams = {};
  isShowModal = false;

  // format!: (val: number) => string;

  // @Watch('page')
  // onPageChange() {
  // this.$router.push({
  //   query: { ...this.$route.query },
  // });
  // }

  prev() {
    // this.params.lastTopupDate = this.transactions.shift()?.topup_date;
    this.page -= 1;
    this.getTransaction(null, this.searchParams, this.page);
  }

  next() {
    // this.params.lastTopupDate = this.transactions.pop()?.topup_date;
    this.page += 1;
    this.getTransaction(null, this.searchParams, this.page);
  }

  async getTransaction(columns: any, searchParams: any, pageParams: any) {
    try {
      if (columns) {
        this.columns = columns;
      }
      if (searchParams) {
        this.searchParams = searchParams;
      }
      if (!pageParams) {
        this.page = 0;
      }
      // console.log(`pageParams : ${pageParams}`);

      const { data } = await api2.post('/recon/job/upload/hist', {
        params: searchParams,
        page: this.page,
      });

      this.rows = data.data ? data.data : [];
      this.to = data.data ? data.data.length : 0;
      this.totalItem = data.count;
      this.hasNext = data.next;
      this.hasPrev = data.prev;
      this.loading = false;
      return null;
    } catch (err) {
      console.error(err);
      return err as AxiosError;
    }
  }

  showModal(id: number) {
    try {
      // console.log(`error : ${id}`);
      this.isShowModal = true;
    } catch (err) {
      showToast(ToastType.FAILED, 'Error', 'error');
    }
  }

  closeModal() {
    this.isShowModal = false;
  }
}
